import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, VStack } from "native-base";
import { formatDateTime } from "@madmedical/utils";
import { ProviderConnectionStatus, logisticsForHumans, } from "@madmedical/medical";
import { useTranslation } from "@madmedical/i18n";
import Card from "../atoms/Card/Card";
import AvatarTexts from "../molecules/AvatarTexts";
import HorizontalListItem from "../molecules/ListItem/HorizontalListItem";
import useResponsive from "../util/useResponsive";
import getImage from "./DeviceItem/getImage";
const DeviceCard = ({ device }) => {
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    return isSmallScreen ? (_jsx(AvatarTexts, { source: getImage(device.provider), label: device.deviceName, subText: t(`backend:${device.manufacturer}`), status: device.status === ProviderConnectionStatus.Off
            ? undefined
            : device.status, isCircle: false, size: "2xl" })) : (_jsx(Card, Object.assign({ header: _jsx(AvatarTexts, { source: getImage(device.provider), label: device.deviceName, subText: t(`backend:${device.manufacturer}`), status: device.status === ProviderConnectionStatus.Off
                ? undefined
                : device.status, isCircle: false, size: "2xl" }), maxWidth: "full" }, { children: _jsxs(VStack, Object.assign({ mt: 6, space: 5, divider: _jsx(Divider, { bg: "gray.100" }) }, { children: [device.ownership && (_jsx(HorizontalListItem, { p: 0, label: t("type"), content: logisticsForHumans(device.ownership) })), device.lastRecordedAt && (_jsx(HorizontalListItem, { p: 0, label: t("lastConnection"), content: formatDateTime(device.lastRecordedAt) }))] })) })));
};
export default DeviceCard;
